import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import '../../scss/Header.scss';

export default class Header extends Component {
  render() {
    return (
      <div className="Header">
        <div className="Header__date">Vote Tuesday 11/7</div>
        <div className="Header__logos">
          <Isvg src={`${ROOT_URL}assets/images/logos/wnyc-logo.svg`} className="wnyc-logo" />
          <Isvg src={`${ROOT_URL}assets/images/logos/gg-logo-white.svg`} className="gotham-gazette-logo" />
          <i className="city-limits-logo">
            <img src={`${ROOT_URL}assets/images/logos/city-limits-logo.png`} />
          </i>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/Header.js